/**
 * Import Lib & assets
 */

import React from "react";
import PropTypes from "prop-types";

/**
 * import components
 */

/**
 * styled components
 */

/**
 * notch component is..
 */

const Svg__notch = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14">
    <path
      fillRule="evenodd"
      fill="#444"
      d="M5.907 13.652l-.129.088-5.22-5.374 2.459-2.468L5.82 8.806 13.715.744l2.46 2.511L5.907 13.652z"
    />
  </svg>
);

export default Svg__notch;

Svg__notch.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Svg__notch.defaultProps = {
  style: {},
};

/*
    import Svg__notch from 'components/svg/notch/svg__notch'
    <Svg__notch />
  */
